import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../utils/ModalEventListener";
import { ToastContainer, toast } from "react-toastify";
import SingleSelectDropDown from "../../layouts/SingleSelectDropDown";
import { encryptRequest } from "../../utils/encryptdecryptrequest";
import { axios_instance } from "../../api/axios_instance";

const AddEnvConfigModal = ({
  editEnvConfigProps,
  EnvTypes,
  fetchConfigData,
  closeAddEnvConfig,
}) => {
  const [state, setState] = useState({
    key: editEnvConfigProps.key ? editEnvConfigProps.key : "",
    value: editEnvConfigProps.value ? editEnvConfigProps.value : "",
    status: editEnvConfigProps.status ? editEnvConfigProps.status : "",
    addEnvType: editEnvConfigProps.env_type ? editEnvConfigProps.env_type : "",
  });

  const ref = useRef();

  useEffect(() => {
    return modalEventListener(ref, closeAddEnvConfig);
  }, [closeAddEnvConfig]);

  const handleInputChange = (e, inputName) => {
    setState({ ...state, [inputName]: e.target.value });
  };

  let EnvTypeList = [
    EnvTypes[0],
    { text: "All Env type", value: "all" },
    ...EnvTypes.slice(1),
  ];

  EnvTypeList = EnvTypeList.map((envVal) => {
    if (envVal.value === "all") return { ...envVal };
    return { text: envVal.text, value: envVal.id ? envVal.id : "" };
  });

  const isEdit = Object.keys(editEnvConfigProps).length;

  const submitEnvData = async () => {
    toast.dismiss();
    try {
      if (!state.key) {
        return toast.error("Please enter a key", { theme: "colored" });
      }
      if (!state.value) {
        return toast.error("Please enter a value", { theme: "colored" });
      }
      if (!state.status) {
        return toast.error("Please enter a status", { theme: "colored" });
      }
      if (!state.addEnvType) {
        return toast.error("Please enter an Env Type", { theme: "colored" });
      }
      const reqData = encryptRequest({
        param_key: state.key,
        param_value: state.value,
        status: state.status,
        env_type: state.addEnvType,
        EnvTypes: EnvTypeList,
        id: editEnvConfigProps.id ? editEnvConfigProps.id : "",
        action: isEdit ? "update" : "add",
      });
      const configData = await axios_instance({
        url: "/envConfig/addAndUpdateConfigData",
        method: "POST",
        data: { reqData },
      });
      if (configData.status === 200) {
        await fetchConfigData(true);
        toast.success(
          configData.data.result.msg
            ? configData.data.result.msg
            : "Data Saved Successfully",
          { theme: "colored" }
        );
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message, { theme: "colored" });
      } else {
        toast.error("Something went wrong", { theme: "colored" });
      }
      closeAddEnvConfig();
    }
  };

  return ReactDOM.createPortal(
    <div className="modal-wrapper">
      <ToastContainer
        closeOnClick={false}
        draggable={false}
        closeButton={false}
      />
      <div className="copy-env-config-modal-content" ref={ref}>
        <div className="modal-header">
          <button className="close" onClick={closeAddEnvConfig}>
            <span>&times;</span>
          </button>
          <h4 className="modal-title" id="configModalLabel">
            {isEdit ? "Edit" : "Add"} Env Config
          </h4>
        </div>

        <div className="modal-body">
          <div className="row">
            <div className="form-group col-md-6">
              <label className="add-config-lables">Key *</label>
              <input
                type="text"
                required="required"
                id="add_config_key"
                name="param_key"
                field="key"
                className="form-control"
                value={state.key}
                placeholder="Enter Key"
                onChange={(e) => handleInputChange(e, "key")}
              />
            </div>
            <div className="form-group col-md-6">
              <label className="add-config-lables">Status *</label>
              <div style={{ marginTop: "5px" }} field="status">
                <label>
                  <input
                    type="radio"
                    required="required"
                    name="status"
                    id="config_status_active"
                    style={{ display: "inline-block", top: "-5px" }}
                    checked={state.status === "1"}
                    onClick={() => setState({ ...state, status: "1" })}
                    onChange={() => {}}
                  />
                  Active
                </label>
                <input
                  type="radio"
                  required="required"
                  name="status"
                  id="config_status_inactive"
                  style={{ display: "inline-block", top: "-5px" }}
                  checked={state.status === "0"}
                  onClick={() => setState({ ...state, status: "0" })}
                  onChange={() => {}}
                />
                <label>Inactive</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-6">
              <label className="add-config-lables">Value *</label>
              <input
                type="text"
                required="required"
                id="add_config_value"
                name="param_value"
                field="value"
                className="form-control"
                value={state.value}
                placeholder="Enter Value"
                onChange={(e) => handleInputChange(e, "value")}
              />
            </div>
            <div className="form-group col-md-6">
              <label className="add-config-lables">Env Type *</label>
              <SingleSelectDropDown
                divClassName=""
                dataArr={EnvTypeList}
                handleChange={(e) => handleInputChange(e, "addEnvType")}
                name="add_config_env_type"
                value={state.addEnvType}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            id="save_pdd_detail"
            type="submit"
            className="btn rc-btn_primary"
            onClick={submitEnvData}
          >
            Submit
          </button>
          <button
            type="button"
            className="btn rc-btn_rset"
            onClick={closeAddEnvConfig}
          >
            Close
          </button>
        </div>
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default AddEnvConfigModal;
